import React from "react";
import Dialog from "@material-ui/core/Dialog";
import { DialogContent } from "../components/DialogContent";
import { TextInput } from "../components/TextInput";
import { DialogTitle } from "../components/DialogTitle";
import { SelectInput } from "../components/SelectInput";
import Typography from "@material-ui/core/Typography";
import { getAvaliableUserRoles } from "../utils/userRoles";

export const EditUserDialog = ({
  onCancel,
  onSave,
  saveAvaliable,
  onNameChange,
  onEmailChange,
  onRoleChange,
  onPassChange,
  onPassConfirmChange,
  currentUser,
  name,
  email,
  role,
  pass,
  passConfirm,
  passDoNotMatch
}) => (
  <Dialog scroll="body" onClose={onCancel} open spacing={0}>
    <DialogTitle
      onCancel={onCancel}
      onSave={onSave}
      saveAvaliable={saveAvaliable}
    >
      User: {currentUser.name}
    </DialogTitle>
    <DialogContent>
      <Typography variant="caption">*Required Inputs</Typography>
      <TextInput label="Name" value={name} onChange={onNameChange} required />
      <TextInput
        label="Email"
        value={email}
        onChange={onEmailChange}
        required
        type="email"
      />
      <br />
      <br />
      <SelectInput
        label="Role*"
        value={role}
        options={getAvaliableUserRoles()}
        onChange={onRoleChange}
      />
      <br />
      <br />
      <Typography variant="subtitle2">
        <b>Update Password</b>
      </Typography>
      <Typography variant="caption">
        Leave fields blank to keep the same password
      </Typography>
      <TextInput
        label="Password"
        value={pass}
        onChange={onPassChange}
        required
        type="password"
      />
      <TextInput
        label="Re-enter Password"
        value={passConfirm}
        onChange={onPassConfirmChange}
        required
        error={passDoNotMatch}
        type="password"
      />
    </DialogContent>
  </Dialog>
);
